import { login } from './userCenter/login.js'
import list from './list.js'
export default {
  login,
  list
}



// WEBPACK FOOTER //
// ./src/comm/api/index.js